export const TYPE_ROUND_ROBIN_ALL = 'round_robin_all';
export const TYPE_ROUND_ROBIN_ROLE = 'round_robin_role';
export const TYPE_ROUND_ROBIN_TEAM_MEMBERS = 'round_robin_team_members';
export const TYPE_TEAM_MEMBER = 'team_member';
export const TYPE_TEAM_SELECTOR_FIELD = 'team_selector_field';
export const TYPE_RELATED_TEAM_SELECTOR_FIELD = 'related_team_selector_field';

export const assignmentTypeOptionsTranslated = (isGlobalAutomation, t) =>
  isGlobalAutomation
    ? [
        {
          label: t('Specific Team Member'),
          value: TYPE_TEAM_MEMBER,
        },
      ]
    : [
        {
          label: t('Round Robin (Any Role)'),
          value: TYPE_ROUND_ROBIN_ALL,
        },
        {
          label: t('Round Robin (Specific Role)'),
          value: TYPE_ROUND_ROBIN_ROLE,
        },
        {
          label: t('Round Robin (Choose Team Members)'),
          value: TYPE_ROUND_ROBIN_TEAM_MEMBERS,
        },
        {
          label: t('Specific Team Member'),
          value: TYPE_TEAM_MEMBER,
        },
        {
          label: t('Team Selector Field (This Object)'),
          value: TYPE_TEAM_SELECTOR_FIELD,
        },
        {
          label: t('Team Selector Field on Related Object'),
          value: TYPE_RELATED_TEAM_SELECTOR_FIELD,
        },
      ];

export const dictionaryAassignmentTypeOptionsTranslated = (
  isGlobalAutomation,
  t
) =>
  assignmentTypeOptionsTranslated(isGlobalAutomation, t).reduce(
    (acc, { label, value }) => ({
      ...acc,
      [value]: { value, label },
    }),
    {}
  );
